export default "{\n    \"viewJob\": \"VOIR LE CONTRAT\"\n}\n"